import { Switch } from 'react-router-dom';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { useLockedFeatures } from '../../providers/LockedFeatures.provider';
import AccountingSystemContainer from './AccountingSystem/AccountingSystemContainer';
import CreateInvoicePage from './CreateInvoice/CreateInvoicePage';
import CreateBillPage from './CreateBill/CreateBillPage';
import { JSX } from 'react';

const Routes = (): JSX.Element => {
  const lockedFeatures = useLockedFeatures();
  const featureFlags = useModuleFeatureFlag('software');

  return (
    <Switch>
      <ProtectedRoute
        isAllowed={!!lockedFeatures.AccountingSoftwareIntegrationEnabled && featureFlags.isEnabled}
        showPermission
        exact
        path="/receivables"
      >
        <AccountingSystemContainer Type="Receivable" />
      </ProtectedRoute>
      <ProtectedRoute
        isAllowed={!!lockedFeatures.AccountingSoftwareIntegrationEnabled && featureFlags.isEnabled}
        showPermission
        exact
        path="/payables"
      >
        <AccountingSystemContainer Type="Payable" />
      </ProtectedRoute>
      <ProtectedRoute
        isAllowed={!!lockedFeatures.AccountingSoftwareIntegrationEnabled && featureFlags.isEnabled}
        showPermission
        exact
        path="/receivables/create-invoice"
      >
        <CreateInvoicePage />
      </ProtectedRoute>
      <ProtectedRoute
        isAllowed={!!lockedFeatures.AccountingSoftwareIntegrationEnabled && featureFlags.isEnabled}
        showPermission
        exact
        path="/payables/create-bill"
      >
        <CreateBillPage />
      </ProtectedRoute>
    </Switch>
  );
};

export default Routes;
